import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { CauHinhCoQuan } from './cau-hinh-co-quan';
@Injectable()
export class CauHinhCoQuanService {
    controller:string = 'HT_CauHinhCoQuan';
    constructor(private http: Http) { } 

    GetDetail() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + this.controller + '/GetDetails', { headers: headers }).map(resp => resp.json());       
    }
    GetOTP() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + this.controller + '/GetOTP', { headers: headers }).map(resp => resp.json());       
    }
    Save(item:CauHinhCoQuan) {
        console.log(item);
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/Save', item, { headers: headers }).map(resp => resp.json());       
    }       
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/cau-hinh-co-quan/cau-hinh-co-quan.service.ts